var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-icon",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 80,
    y2: 80
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "startButton.click",
    attributeType: "XML",
    attributeName: "y1",
    from: 20,
    to: 50,
    dur: "0.5s",
    repeatCount: 1,
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "startButton.click",
    attributeType: "XML",
    attributeName: "y2",
    from: 80,
    to: 50,
    dur: "0.5s",
    repeatCount: 1,
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "startButton.click",
    attributeType: "XML",
    attributeName: "x1",
    from: 20,
    to: 10,
    dur: "0.5s",
    repeatCount: 1,
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "startButton.click",
    attributeType: "XML",
    attributeName: "x2",
    from: 80,
    to: 90,
    dur: "0.5s",
    repeatCount: 1,
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 80,
    x2: 80,
    y2: 20
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "startButton.click",
    attributeType: "XML",
    attributeName: "y1",
    from: 80,
    to: 50,
    dur: "0.5s",
    repeatCount: 1,
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "startButton.click",
    attributeType: "XML",
    attributeName: "y2",
    from: 20,
    to: 50,
    dur: "0.5s",
    repeatCount: 1,
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "startButton.click",
    attributeType: "XML",
    attributeName: "x1",
    from: 20,
    to: 10,
    dur: "0.5s",
    repeatCount: 1,
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "startButton.click",
    attributeType: "XML",
    attributeName: "x2",
    from: 80,
    to: 90,
    dur: "0.5s",
    repeatCount: 1,
    fill: "freeze"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "startButton",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    fill: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.c81028791160a6f1b9a24ed1f7d72db7.svg";
export { ForwardRef as ReactComponent };